/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Camera_DeniedInputs */

const en_us2_body_assessment_camera_denied = /** @type {(inputs: Body_Assessment_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app needs the camera to take these photos. Allow it in your phone's settings.`)
};

const pt_br2_body_assessment_camera_denied = /** @type {(inputs: Body_Assessment_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O app precisa da câmera para tirar essas fotos. Libere a permissão nas configurações do celular.`)
};

const es_419_body_assessment_camera_denied = /** @type {(inputs: Body_Assessment_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La app necesita la cámara para tomar estas fotos. Permítela en los ajustes de tu teléfono.`)
};

const pt_pt2_body_assessment_camera_denied = /** @type {(inputs: Body_Assessment_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A app precisa da câmara para tirar estas fotos. Dá a permissão nas definições do telemóvel.`)
};

const fr_fr2_body_assessment_camera_denied = /** @type {(inputs: Body_Assessment_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'app a besoin de la caméra pour prendre ces photos. Autorise-la dans les réglages du téléphone.`)
};

const de_de2_body_assessment_camera_denied = /** @type {(inputs: Body_Assessment_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die App braucht die Kamera für diese Fotos. Erlaube sie in den Einstellungen deines Handys.`)
};

const it_it2_body_assessment_camera_denied = /** @type {(inputs: Body_Assessment_Camera_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'app ha bisogno della fotocamera per scattare queste foto. Consenti l'accesso nelle impostazioni del telefono.`)
};

/**
* | output |
* | --- |
* | "The app needs the camera to take these photos. Allow it in your phone's settings." |
*
* @param {Body_Assessment_Camera_DeniedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_camera_denied = /** @type {((inputs?: Body_Assessment_Camera_DeniedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Camera_DeniedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_camera_denied(inputs)
	if (locale === "es-419") return es_419_body_assessment_camera_denied(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_camera_denied(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_camera_denied(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_camera_denied(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_camera_denied(inputs)
	return en_us2_body_assessment_camera_denied(inputs)
});
export { body_assessment_camera_denied as "body-assessment.camera_denied" }